import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { gooseCreekConfig } from "./data";

export default function GooseCreekPage() {
  return <CityPageTemplate config={gooseCreekConfig} />;
}